import React, { Component } from "react";
import { Table, Modal, Image } from "react-bootstrap";

import { appConfig } from "../../../config";
import InvoicePDFView from "./chemistinvoicepdfview";
import ModalImage from "react-modal-image";
import "../../Common/Common.css";
var dateFormat = require("dateformat");
class ChemistInvoiceView extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  mouseOver = data => {
    this.setState({ invoicePdfModal: true, InvoiceData: data });
  };

  closePdfModel=()=>{
    this.setState({invoicePdfModal:false})
  }

  getExtension = filename => {
    return filename.split(".").pop();
  };

  render() {
    const data =
      this.props.ChemistInvoiceDtls && this.props.ChemistInvoiceDtls.item
        ? this.props.ChemistInvoiceDtls && this.props.ChemistInvoiceDtls.item
        : null;

    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>
                  Chemist Invoice Details
                </span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="feedbkModalTbl">
                  <Table responsive bordered className="cmnMainTable">
                    <thead></thead>
                    <tbody>
                    <tr>
                        <td>Order ID</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.orderId &&
                            data.orderId.orderNo}
                        </td>
                      </tr>
                      <tr>
                        <td>Order Type</td>
                        <td className="storeModalCap">
                          {data !== null && data.orderType}
                        </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth">Reference Number</td>
                        <td className="storeModalCap">
                          {data !== null && data.invNo}
                        </td>
                      </tr>
                      <tr>
                        <td>Chemist Name</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.vendorId &&
                            data.vendorId.fullName}
                        </td>
                      </tr>
                      <tr>
                        <td>Chemist Organisation</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.chmstDtls &&
                            data.chmstDtls.name}
                        </td>
                      </tr>
                      <tr>
                        <td>Distributor Name</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.customerId &&
                            data.customerId.fullName}
                        </td>
                      </tr>
                      <tr>
                        <td>Distributor Organization</td>
                        <td className="storeModalCap">
                          {data !== null && data.dstbtrDtls && data.dstbtrDtls.name}
                        </td>
                      </tr>
                      
                      <tr>
                        <td>Amount</td>
                        <td className="storeModalCap">
                          {data !== null && data.amount}
                        </td>
                      </tr>
                      <tr>
                        <td>Invoice Preview</td>
                        <td className="storeModalCap">

                        <div>
                          {data && data.imgUrl ? (
                            this.getExtension(data.imgUrl) === "pdf" ? (
                              <div>
                                <Image
                                  className="ctgryImg"
                                  style={{cursor:"pointer"}}
                                  src={[
                                    data && data.imgUrl !== undefined
                                      ? require("../../../assets/img/default_pdf_icon.png")
                                      : "No Preview"
                                  ]}
                                  onClick={() =>
                                    data.imgUrl !== undefined
                                      ? this.mouseOver({ data: data.imgUrl })
                                      : null
                                  }
                                />
                                <InvoicePDFView
                                  show={this.state.invoicePdfModal}
                                  handleClose={this.closePdfModel}
                                  InvoiceData={this.state.InvoiceData}
                                />
                              </div>
                            ) : (
                              <ModalImage
                                small={
                                  data &&
                                  data.imgUrl &&
                                  appConfig.imgServerip +
                                    `/getInvImg?imgName=${data.imgUrl}`
                                }
                                large={
                                  data &&
                                  data.imgUrl &&
                                  appConfig.imgServerip +
                                    `/getInvImg?imgName=${data.imgUrl}`
                                }
                                hideDownload={true}
                                hideZoom={true}
                                className="ctgryImg"
                              />
                            )
                          ) : null}
                        </div>
                        </td>
                      </tr>
                      {/*                       <tr>
                        <td>Payable Amount</td>
                        <td className="storeModalCap">
                              {data !== null && data.payableAmnt}
                            </td>
                      </tr>
                      <tr>
                        <td>Tax Amount</td>
                        <td className="storeModalCap">
                              {data !== null && data.taxAmnt}
                            </td>
                      </tr>
                      <tr>
                        <td>Commission Amount</td>
                        <td className="storeModalCap">
                              {data !== null && data.commissionAmnt}
                            </td>
                      </tr>
                      <tr>
                        <td>Voucher No.</td>
                        <td className="storeModalCap">
                              {data !== null && data.vouchrNo}
                            </td>
                      </tr>
                      <tr>
                        <td>Voucher Date</td>
                        <td className="storeModalCap">
                              {data !== null && data.vouchrDate != null && 
                              dateFormat(data.vouchrDate, "mediumDate")}
                            </td>
                      </tr>
 */}{" "}
                      <tr>
                        <td>Created Date</td>
                        <td className="feedbkModalCap">
                          {data !== null &&
                            data.createdAt !== null &&
                            dateFormat(data.createdAt, "mediumDate")}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default ChemistInvoiceView;
